
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { usePromotionBoosterList } from '@/modules/promotion/booster/model/list';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.BOOSTER.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, actions } = usePromotionBoosterList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                {
                    type: TableColumnType.RouterLink,
                    label: 'Linked Promotion',
                    key: 'linkedItemName',
                    to: row => row.linkedItemLink
                },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_PROMOTION.BOOSTER.EDIT, params: { id: row.id } }
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_PROMOTION.BOOSTER.DETAIL, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, ROUTE_NAME_PROMOTION };
    }
});
